import store from '@/store';

export default (to, from, next) => ({
    allow: store.getters.is_app_environment_prod,
    redirect: { name: 'not-found' },
});
